import { useQuery } from '@tanstack/react-query'

import { useApi } from '@/hooks'
import { AssetState } from '@/types/asset-types'

const useAssetState = (assetId?: number) => {
  const { api } = useApi()
  return useQuery({
    queryKey: ['asset-state', assetId],
    queryFn: () =>
      api.simpleGet<AssetState>({
        path: `assets/state/${assetId}`,
        origin: '',
      }),
    enabled: !!assetId,
    staleTime: 60_000,
  })
}

export default useAssetState
